if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      // console.log(MutationList);
      for (let item of MutationList) {
        if (item.target.id === "cart-icon-bubble") {
          BSS_B2B.observer.cartSubject.listenCartCheckout();
          handleCartDrawerFooterMutation();
          initBSSnt()
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }, 300);

  setTimeout(() => {
    addCartIconClickEvent();
    handleCartDrawerFooterMutation();
  }, 2000);

  function addCartIconClickEvent() {
    const cartIcons = document.querySelectorAll("#cart-icon");
    if (cartIcons.length > 0) {
      cartIcons.forEach((icon) => {
        icon.addEventListener(
          "click",
          () => {
            setTimeout(() => {
              handleCartDrawerFooterMutation();
            }, 500);
          },
          true
        );
      });
    }
  }

  function initBSSnt() {
    if (BSS_B2B?.nt) {
      BSS_B2B.nt.initFunction();
      document.dispatchEvent(new Event("DOMContentLoaded"));
    }
  }

  async function handleCartDrawerFooterMutation() {
    if (BSS_B2B) {
      const res = await BSS_B2B.storage.productStorage.load();
      if (res) {
        if (
          res.notExistProductIds?.length ||
          res.productIds?.length ||
          res.variantIds?.size
        ) {
          BSS_B2B.observer.productSubject.notifyObserver(
            "LazyProduct",
            "LoadedLazyProduct",
            {
              ...res,
            }
          );
        }
      }
    }
  }
}


const checkoutBtn = document.querySelector(`[name="checkout"]`);
const NTButton = document.querySelector(`#bss-b2b-net-term-button-wrapper`);
if(checkoutBtn && NTButton) {
  handleNT();
}

function handleNT (){
  if(!BSS_B2B.nt || document.querySelector("#bss-b2b-net-term-button") == null) return;
  const checkoutBtn = document.querySelector(`[name="checkout"]`);
  const wrapper = document.createElement('div');
  wrapper.id = 'bss-b2b-net-term-button-wrapper';
  
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'bss-netterm';
  btn.dataset.initialized = 'true';
  btn.textContent = 'Request Quote';
  
  Object.assign(btn.style, {
    display: 'inline-flex',
    pointerEvents: 'auto',
    cursor: 'pointer',
    opacity: '1',
  });
  
  wrapper.appendChild(btn);
  checkoutBtn.before(wrapper);
  btn.addEventListener("click", e => {
    document.querySelector("#bss-b2b-net-term-button").click();
  });
}

document.addEventListener("handleNT", e => {
  handleNT();
});
